import {createModel} from "~~/package/utils/ModelUtil";
import Model from "~~/package/mapper/Model";

export class ProSkillAssureTestTemplateModel extends Model {
    constructor(
        public id: number = 0,
        public title: string = "",
        public passScore: number = 0,
        public createdAt: number = 0,
        public updatedAt: number = 0,
    ) {
        super();
    }

    public static create(model: Partial<ProSkillAssureTestTemplateModel>): ProSkillAssureTestTemplateModel {
        return createModel<ProSkillAssureTestTemplateModel>(ProSkillAssureTestTemplateModel, {
            ...model
        });
    }
}
